import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import { moduleAction } from "../../utils/functions";
import { MOD_PROVID, WRITE } from "../../../permissions";
import { getRoles } from "../../../Redux/reducer/session";
import AddBlue from "../../../../static/images/add-blue.svg";
import Provider from "../../../../static/images/add-client-bsc.svg";
import AddContact from "../../../../static/images/add-contact.svg";

export class BlankProvider extends Component {
  render() {
    const { roles, t } = this.props;
    return (
      <React.Fragment>
        <div className="blank-provider">
          <div className="content-provider">
            <img src={Provider} className="clientImage" />
            <h3>{`${t('providers.blank.welcome').replace('%company', this.props.institutionName)}`}<br />{`${t('providers.blank.welcome2')}`}</h3>
            <div className="line line-bsc red"></div>
            <p>{`${t('providers.blank.description')}`}</p>
            {moduleAction(roles, MOD_PROVID, WRITE) && (
              <Link to="/providers/add" className="add-btn">
                <img src={AddContact} alt={`${t('providers.blank.add')}`} />
                {`${t('providers.blank.add')}`}
                <img src={AddBlue} alt={`${t('providers.blank.add')}`} />
              </Link>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = state => {
  return {
    roles: getRoles(state),
    institutionName: state.sessionInfoReducer.sessionInfo.institutionName
  };
};

export default connect(mapStateToProps, null)(withTranslation()(BlankProvider));